import React, { useState } from 'react';
import { useSearchParams } from 'react-router';
import AnalystHeader from './AnalystHeader';
import AnalystSidebar from './AnalystSidebar';

// Risk Components
import RiskOverview from '../../components/risk/RiskOverview';
import RiskRegisterMock from '../../components/risk/mock/RiskRegisterMock';
import RiskAssessments from '../../components/risk/RiskAssessments';
import RiskVulnerabilities from '../../components/risk/RiskVulnerabilities';

// Control Components
import ControlMasterMock from '../../components/internalControls/mock/ControlMasterMock';
import ControlTesting from '../../components/internalControls/ControlTesting';
import ControlDeficiencies from '../../components/internalControls/ControlDeficiencies';

// Monitoring Components
import RulesTab from '../../components/monitoring/RulesTab';
import EventsTab, { Risk } from '../../components/monitoring/EventsTab';
import AnalyticsTab from '../../components/monitoring/AnalyticsTab';

// CAPA Components
import InvestigationsTab from '../../components/capa/InvestigationsTab';

const AnalystDashboard: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView = searchParams.get('view') || 'DASHBOARD';
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const setActiveView = (view: string) => {
    setSearchParams({ view });
  };

  // State for Monitoring components interaction
  const [risks, setRisks] = useState<Risk[]>([]);
  const openRisksCount = risks.filter(r => r.status === 'Open').length;

  const renderContent = () => {
    switch (activeView) {
      case 'DASHBOARD':
        return <div className="p-6 h-full overflow-auto"><RiskOverview /></div>;
      case 'RISK_REGISTER':
        return <div className="p-6 h-full overflow-auto"><RiskRegisterMock /></div>;
      case 'ASSESSMENTS':
        return <div className="p-6 h-full overflow-auto"><RiskAssessments /></div>;
      case 'VULNERABILITIES':
        return <div className="p-6 h-full overflow-auto"><RiskVulnerabilities /></div>;
      case 'CONTROL_REGISTER':
        return <div className="p-6 h-full overflow-auto"><ControlMasterMock /></div>;
      case 'TESTING':
        return <div className="p-6 h-full overflow-auto"><ControlTesting /></div>;
      case 'DEFICIENCIES':
        return <div className="p-6 h-full overflow-auto"><ControlDeficiencies /></div>;
      case 'RULES':
        return <div className="p-6 h-full overflow-auto"><RulesTab /></div>;
      case 'EVENTS':
        return <div className="p-6 h-full overflow-auto"><EventsTab onRisksChange={setRisks} /></div>;
      case 'ANALYTICS':
        return <div className="p-6 h-full overflow-auto"><AnalyticsTab openRisksCount={openRisksCount} /></div>;
      case 'INVESTIGATIONS':
        return <div className="p-6 h-full overflow-auto"><InvestigationsTab /></div>;
      default:
        return <div className="p-6">View not found</div>;
    }
  };

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-slate-50">
      <AnalystHeader onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />

      <div className="analyst-layout flex-1">
        <AnalystSidebar activeView={activeView} onViewChange={setActiveView} isOpen={isSidebarOpen} />

        <main className="analyst-main-content relative w-full h-full overflow-hidden">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default AnalystDashboard;
